import React from 'react';
import { Helmet } from 'react-helmet';
import NavBar from '../components/NavBar';
import ModelViewer from '../components/ModelViewer';
import Footer from '../components/Footer';
import './ProductPage.css';

const ProductPage = () => {
  // Define the base URL for assets
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className="product-container">
      <Helmet>
        <title>Sun Blocks - Product Specifications</title>
        <meta property="og:title" content="Sun Blocks Product Specifications" />
        <meta property="og:description" content="Detailed specifications for Sun Blocks automated sunscreen dispensers." />
      </Helmet>
      
      <NavBar />
      
      <div className="product-content">
        {/* Top Left Content Section */}
        <div className="product-info-section">
          <span className="product-label">Technical Specifications</span>
          <h1 className="product-headline"><strong style={{ color: '#FBB040' }}>Sun Blocks</strong> Automated Sunscreen Dispenser</h1>
          <p className="product-description">
            Our state-of-the-art sunscreen dispenser combines advanced technology with sustainable design to provide 
            convenient, high-quality sun protection at your venue to enhance guest experience.
          </p>
          
          {/* Features List */}
          <div className="product-features">
            <h2 className="features-heading">Key Features</h2>
            
            <div className="features-category">
              <h3 className="category-title">Design & Durability</h3>
              <ul className="features-list">
                <li><span className="feature-bullet">•</span> Durable & Weather-Resistant – Built for outdoor use with rugged, industrial-grade construction</li>
                <li><span className="feature-bullet">•</span> Compact & Modular Design – Easy to install in various locations with a sleek yet functional build</li>
              </ul>
            </div>
            
            <div className="features-category">
              <h3 className="category-title">Dispensing Technology</h3>
              <ul className="features-list">
                <li><span className="feature-bullet">•</span> Touchless-Dispensing – Pay and receive your sunscreen without having to touch the dispenser</li>
                <li><span className="feature-bullet">•</span> Hand Recognition – Hand recognition ensures that the sunscreen is dispensed to a waiting hand</li>
              </ul>
            </div>
            
            <div className="features-category">
              <h3 className="category-title">Maintenance and Monitoring</h3>
              <ul className="features-list">
                <li><span className="feature-bullet">•</span> IoT Indicator System – Remotely monitor the dispenser and receive alerts when it needs servicing</li>
                <li><span className="feature-bullet">•</span> Hassle-Free Maintenance – We handle all maintenance, ensuring your dispenser is always in top condition</li>
              </ul>
            </div>
            
            <div className="features-category">
              <h3 className="category-title">Payment & Integration</h3>
              <ul className="features-list">
                <li><span className="feature-bullet">•</span> Multiple Payment Methods – Supports tap-to-pay, mobile, and other digital options</li>
                <li><span className="feature-bullet">•</span> Smart Software Integration – Contact us for options on membership verification and more</li>
              </ul>
            </div>
            
            <div className="features-category">
              <h3 className="category-title">Community Focus</h3>
              <ul className="features-list">
                <li><span className="feature-bullet">•</span> Community Partnership – 10% of all revenue goes to your local community</li>
                <li><span className="feature-bullet">•</span> Solar-Powered Operation – Runs entirely on renewable energy for sustainable functionality</li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Right Side Model Viewer and Exploded View in separate wrappers */}
        <div className="product-model-section">
          <div className="model-container-wrapper">
            <h3 className="model-title">Interactive 3D Model</h3>
            <div className="model-viewer-container">
              <ModelViewer />
            </div>
          </div>
          
          <div className="product-image-wrapper">
            <h3 className="exploded-view-title">Exploded View</h3>
            <div className="product-image-container">
              <img 
                src={`${publicUrl}/product_blowout.jpg`}
                alt="Sun Blocks Dispenser Product Details" 
                className="product-detail-image"
              />
              <p className="product-image-caption">Figure 1: <strong style={{ color: '#FBB040' }}>Sun Blocks</strong> exploded view</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* CTA Section - Updated to focus on scheduling a demo */}
      <div className="product-cta-section">
        <div className="product-cta-content">
          <h3>Ready to enhance your venue with <strong style={{ color: '#FBB040' }}>Sun Blocks</strong>?</h3>
          <p>Schedule a demo to see how our sunscreen dispensers can benefit your guests and your business.</p>
          <div className="product-cta-buttons">
            <button 
              className="product-cta-button"
              onClick={() => window.location.href = '/contact'}
            >
              Schedule a Demo
            </button>
            <button 
              className="product-download-button"
              onClick={() => window.location.href = '/partners'}
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ProductPage;